"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSignInOptionButtonMobile = exports.StyledSignInOptionButtonDesktop = exports.StyledButton = exports.PickerContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = require("../Button");
var _SignInOptionButton = require("../SignInOptionButton");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
//components

var PickerContainer = exports.PickerContainer = _styledComponents["default"].div.withConfig({
  displayName: "styles__PickerContainer",
  componentId: "sc-1v37ko0-0"
})(["flex:5;"]);
var StyledSignInOptionButtonMobile = exports.StyledSignInOptionButtonMobile = (0, _styledComponents["default"])(_SignInOptionButton.SignInOptionButtonMobile).withConfig({
  displayName: "styles__StyledSignInOptionButtonMobile",
  componentId: "sc-1v37ko0-1"
})(["margin-bottom:16px;"]);
var StyledSignInOptionButtonDesktop = exports.StyledSignInOptionButtonDesktop = (0, _styledComponents["default"])(_SignInOptionButton.SignInOptionButtonDesktop).withConfig({
  displayName: "styles__StyledSignInOptionButtonDesktop",
  componentId: "sc-1v37ko0-2"
})(["margin-bottom:16px;"]);
var StyledButton = exports.StyledButton = (0, _styledComponents["default"])(_Button.Button).attrs({
  design: 'text-alternative-hover'
}).withConfig({
  displayName: "styles__StyledButton",
  componentId: "sc-1v37ko0-3"
})(["text-transform:unset !important;margin:auto;"]);
//# sourceMappingURL=styles.js.map